<button [class]="!copiedMessage ? 'btn btn-sm btn-outline-secondary mt-2' : 'btn btn-sm btn-secondary mt-2 disabled'" type="button" (click)="copyToClipboard(block.dataKey)">
    <i [class]="!copiedMessage ? 'fas fa-clone mr-2' : 'fas fa-check-circle mr-2'"></i>{{ !copiedMessage ? 'Copy' : 'Copied' }}
</button>